// components/TestAnswerForm.js
import React, { Component } from "react";

export default class TestAnswerForm extends Component {
  state = {
    answerText: "",
    loading: false,
  };

  handleInputChange = (event) => {
    this.setState({ answerText: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.state.answerText.trim()) {
      alert("Answer text cannot be empty.");
      return;
    }
    this.setState({ loading: true });
    try {
      await this.props.onSubmit(this.state.answerText);
      this.setState({ answerText: "" }); // Clear form on success
    } catch (error) {
      console.error("Error submitting test answer:", error);
      // alert("Failed to submit test answer. Check console."); // Handled by parent
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { onCancel } = this.props;
    const { answerText, loading } = this.state;

    return (
      <form onSubmit={this.handleSubmit} className="mt-3">
        <div className="field">
          <label
            className="label is-small"
            htmlFor={`testAnswerText-${this.props.languageVersion.commonQuestionId}-${this.props.languageVersion.languageCode}`}
          >
            Answer Text
          </label>
          <div className="control">
            <textarea
              id={`testAnswerText-${this.props.languageVersion.commonQuestionId}-${this.props.languageVersion.languageCode}`}
              className="textarea is-small"
              name="answerText"
              value={answerText}
              onChange={this.handleInputChange}
              placeholder="Enter the answer text..."
              rows="3"
              required
            />
          </div>
        </div>
        <div className="buttons are-small mt-2">
          <button
            type="submit"
            className="button is-success"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Answer"}
          </button>
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="button"
              disabled={loading}
            >
              Cancel
            </button>
          )}
        </div>
      </form>
    );
  }
}
